import script from "./SortableTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SortableTable.vue?vue&type=script&setup=true&lang=js"

import "./SortableTable.vue?vue&type=style&index=0&id=8aa2e75c&lang=scss&scoped=true"

import exportComponent from "/opt/streamify/admin/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8aa2e75c"]])

export default __exports__